import { useState, useCallback } from "react";
import logger from "../services/Logger";

/**
 * Hook for copying text to clipboard with a temporary "copied" state.
 * @param {object} options
 * @param {number} options.resetDelay - ms before resetting copied state (default: 1000)
 * @param {string} options.caller - component name for error logging
 * @returns {{ copied: boolean, copyToClipboard: (text: string) => Promise<void> }}
 */
const useCopyToClipboard = ({ resetDelay = 1000, caller = "Unknown" } = {}) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = useCallback(async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), resetDelay);
    } catch (err) {
      logger.error(caller, "Failed to copy to clipboard", { error: err.message });
    }
  }, [resetDelay, caller]);

  return { copied, copyToClipboard };
};

export default useCopyToClipboard;
